<template>
  <div id="id-article-share" :class="{ 'is-app': isFromApp }">
    <div class="article-main">
      <div class="article-title">{{ articleData.title }}</div>
      <div class="article-info">
        <!-- 头像 -->
        <div
          class="article-avatar"
          v-if="articleData.managerImgPublicUrl != ''"
        >
          <img
            @click="jumpManagerDetail(articleData)"
            :src="articleData.managerImgPublicUrl"
            alt=""
          />
        </div>
        <!-- 名字 -->
        <div>
          <div
            class="article-name"
            :class="
              (articleData.transferFrom != '' || articleData.source != '') &&
              articleData.managerImgPublicUrl != ''
                ? 'flx'
                : ''
            "
            v-if="articleData.managerName != ''"
          >
            <span
              v-if="articleData.transferFrom != '' && articleData.source != ''"
              style="
                font-size: 12px;
                color: #999999;
                font-weight: normal;
                font-family: PingFangSC-Regular;
              "
              >{{ articleData.managerName }}</span
            >

            <span
              v-else
              style="color: #222222; font-family: PingFangSC-Medium"
              >{{ articleData.managerName }}<span
                v-if="
                  articleData.transferFrom == '' && articleData.source == '' && articleData.articleType!=''
                "
                class="new-tip"
                @click="handleTip(articleData.articleType)"
                >{{ articleData.articleType }}</span
              ></span
            >

            <div
              class="article-time flx"
              v-if="articleData.transferFrom !== '' || articleData.source != ''"
            >
              <span style="margin: 0 4px">·</span>{{ articleData.postDate }}
              <div class="article-time">
                <span style="margin: 0 4px">·</span>阅读量&nbsp;&nbsp;{{
                  articleData.readingQuantity
                }}<span
                  v-if="articleData.articleType!=''"
                  class="new-tip"
                  @click="handleTip(articleData.articleType)"
                  >{{ articleData.articleType }}</span
                >
              </div>
            </div>
          </div>

          <div
            class="article-time flx"
            v-if="
              (articleData.transferFrom !== '' || articleData.source !== '') &&
              articleData.managerImgPublicUrl != ''
            "
          >
            {{ articleData.transferFrom == "" ? "来源：" : "转载自："
            }}<span class="zz1">{{
              articleData.transferFrom == ""
                ? articleData.source
                : articleData.transferFrom
            }}</span>
          </div>

          <!-- //时间 -->
          <div
            class="article-time flx"
            style="margin-top: 3px"
            v-if="
              (articleData.transferFrom !== '' || articleData.source !== '') &&
              articleData.managerImgPublicUrl == ''
            "
          >
            <div class="article-time flx">
              <!-- <span
                class="new-tip"
                @click="handleTip(articleData.articleType)"
                >{{ articleData.articleType }}</span
              > -->
              {{ articleData.transferFrom == "" ? "来源：" : "转载自："
              }}<span class="zz">{{
                articleData.transferFrom == ""
                  ? articleData.source
                  : articleData.transferFrom
              }}</span
              ><span style="margin: 0 4px">·</span>
            </div>
            {{ articleData.postDate }}
          </div>

          <div
            class="article-time flx"
            v-if="
              articleData.transferFrom == '' &&
              articleData.managerImgPublicUrl != '' &&
              articleData.source == ''
            "
          >
            {{ articleData.postDate }}
            <div class="article-time">
              <span style="margin: 0 4px">·</span>阅读量&nbsp;&nbsp;{{
                articleData.readingQuantity
              }}
            </div>
          </div>
          <div
            class="article-info flx"
            v-if="
              articleData.transferFrom == '' &&
              articleData.managerImgPublicUrl == '' &&
              articleData.source == ''
            "
          >
            <div class="article-time">
              <span
                v-if="articleData.articleType!=''"
                class="new-tip"
                @click="handleTip(articleData.articleType)"
                >{{ articleData.articleType }}</span
              >
              {{ articleData.postDate }}
            </div>
            <span style="margin: 0 4px">·</span>
            <div class="article-time">
              阅读量&nbsp;&nbsp;{{ articleData.readingQuantity }}
            </div>
          </div>
        </div>
        
        <!-- 阅读量 -->
        <div
          v-if="
            (articleData.transferFrom != '' || articleData.source != '') &&
            articleData.managerImgPublicUrl == ''
          "
        >
          <div
            style="height: 16px"
            v-if="articleData.managerImgPublicUrl != ''"
          ></div>
          <div class="article-time" style="margin-top: 3px">
            <span style="margin: 0 4px">·</span>阅读量&nbsp;&nbsp;{{
              articleData.readingQuantity
            }}
          </div>
        </div>
      </div>
      <div style="display:block;width:100%" v-if="articleData.managerImgPublicUrl == ''&&(articleData.transferFrom != '' || articleData.source != '')">
        <span
          style="margin-left:0"
          v-if="articleData.articleType!=''"
              class="new-tip" 
              @click="handleTip(articleData.articleType)"
              >{{ articleData.articleType }}</span
            >
      </div>
      <div class="article-content" v-html="articleData.content"></div>
      <div class="correlation" v-if="!isEmptied(articleData.relationFunds)">
        <h2 class="correlation-title">相关基金</h2>
        <div class="correlation-cont">
          <span
            class="correlation-item"
            v-for="(item, index) in articleData.relationFunds"
            @click="handleToDetail(item,'funds')"
            :key="index"
            >{{ item.title }}（{{ item.value }}）</span
          >
        </div>
      </div>
      <div class="correlation" v-if="!isEmptied(articleData.relationArticles)">
        <h2 class="correlation-title">相关资讯</h2>
        <div class="correlation-cont">
          <span
            class="correlation-item"
            v-for="(item, index) in articleData.relationArticles"
            @click="handleToDetail(item,'news')"
            :key="index"
            >{{ item.title }}</span
          >
        </div>
      </div>
    </div>
    <DownloadApp />
  </div>
</template>
<script>
import DownloadApp from "../../components/DownloadApp";
import {isEmpty} from "../../plugins/base"
import wx from "weixin-js-sdk";
export default {
  components: {
    DownloadApp,
  },
  name: "",
  data() {
    return {
      articleId: "",
      articleData: {},
      channelUID: "",
      signUrl: "",
      param: {
        jsapi_ticket: "",
        noncestr: "hjt-activity818",
        url: "",
      },
      // isAppAlert: false,
      from: "",
      wxConfig: {
        debug: true, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
        appId: "", // 必填，公众号的唯一标识
        timestamp: "", // 必填，生成签名的时间戳
        nonceStr: "", // 必填，生成签名的随机串
        signature: "", // 必填，签名
        jsApiList: [],
      },
    };
  },
  async created() {
    if (
      this.$route.query.articleId != "" ||
      this.$route.query.articleId != null
    ) {
      this.articleId = this.$route.query.articleId;
    }
    if (this.$route.query.channel != "" || this.$route.query.channel != null) {
      this.channelUID = this.$route.query.channel;
    }
    this.getNewsDetail(this.articleId)
    // const { data } = await this.axios.get(
    //   `https://market.pyamc.com/api/market/manager/queryManagerArticle?articleId=${this.articleId}`
    // );
    // 上报阅读量
    window.setTimeout(() => {
      this.axios.get(
        `https://market.pyamc.com/api/market/news/newsReadingQuantity?articleId=${this.articleId}&count=1`
      );
    }, 3000);

    
  },
  mounted() {
    this.getAccessToken();
    document.title = "基金经理观点";
  },
  methods: {
    isEmptied(v){
      return isEmpty(v);
    },

    async getNewsDetail(articleId){
      const fat = false;
      const { data } = fat ? await this.axios.get(
            `https://fat-market.pyamc.com/api/market/manager/queryManagerArticle?articleId=${articleId}`
          )
        : await this.axios.get(
            `https://market.pyamc.com/api/market/manager/queryManagerArticle?articleId=${articleId}`
          );
          let val = data.data.postDate;
    let d;
    // 做ios时间兼容用“/”替换“-”，去除.0是数据库格式化时间时在时间后边带了毫秒，后台会处理
    let D = val.replace(/\-/g, "/");
    if (val.endsWith(".0")) {
      console.log(D.replace(/\.0/g, ""));
      d = new Date(D.replace(/\.0/g, ""));
    } else {
      d = new Date(D);
    }
    // 时间格式化
    let getMin =
      (d.getMinutes() + "").length <= 1
        ? "0" + (d.getMinutes() + "")
        : d.getMinutes() + "";
    let getHou =
      (d.getHours() + "").length <= 1
        ? "0" + (d.getHours() + "")
        : d.getHours() + "";
    let timeDiffHours = getHou + ":" + getMin;
    let timeDiffDay = parseInt(
      (new Date() - new Date(d)) / (1000 * 60 * 60 * 24)
    );

    // 计算今天还是昨天
    let nd = new Date().getDate();
    let nm = new Date().getMonth() + 1;
    let ny = new Date().getFullYear();
    let od = d.getDate();
    let om = d.getMonth() + 1;
    let oy = d.getFullYear();
    // 新的一年
    if (ny - oy == 0) {
      // 新的一月()
      if (nm - om == 0) {
        // 新的一年
        if (nd - od == 0) {
          timeDiffDay = 0; //今天
        } else if (nd - od == 1) {
          timeDiffDay = 1; // 昨天
        } else {
          timeDiffDay = 2; //日期
        }
      } else if (nm - om == 1) {
        // 当前月份减去旧时间
        if (nd == 1) {
          timeDiffDay = 1;
        } else {
          timeDiffDay = 2; //日期
        }
      } else {
        timeDiffDay = 2; //日期
      }
    } else {
      timeDiffDay = 2; // 昨天
    }
    console.log(timeDiffDay);
    let year = d.getFullYear();
    let month =
      (d.getMonth() + 1 + "").length <= 1
        ? "0" + (d.getMonth() + 1 + "")
        : d.getMonth() + 1 + "";
    let day =
      (d.getDate() + "").length <= 1
        ? "0" + (d.getDate() + "")
        : d.getDate() + "";
    let fulldate = year + "-" + month + "-" + day;
    let postDate = "";
    if (timeDiffDay == 0) {
      postDate = timeDiffHours;
    } else if (timeDiffDay == 1) {
      postDate = "昨天" + timeDiffHours;
    } else {
      postDate = fulldate;
    }
    data.data.postDate = postDate;
    this.articleData = data.data;
    },

    handleToDetail(v,str){
      if (str == "news") {
        let newsParam = { articleId:v.id,title:v.title,summary:v.summary};
          let mid = {
            action: "jumpFundsDetail",
            newsParam: newsParam,
          };
          let jumpNewsDetail = JSON.stringify(mid);
          console.log(jumpNewsDetail);
      }else{
        let fundsParam = { name:v.title,code:v.value};
          let mid = {
            action: "jumpFundsDetail",
            fundsParam: fundsParam,
          };
          let jumpFundsDetail = JSON.stringify(mid);
          console.log(jumpFundsDetail);
      }
    },

    jumpManagerDetail(manager) {
      console.log(manager);
      if(!isEmpty(manager.managerId)){
        if (this.isFromApp) {
          let paramsMap = { managerId: manager.managerId };
          let mid = {
            action: "jumpManagerDetail",
            params: paramsMap,
          };
          let StrMid = JSON.stringify(mid);
          console.log(StrMid);
        } 
      }
    },
    getAccessToken() {
      this.signUrl =
        window.location.href.split("cms-app-html/")[0] +
        `cms-app-html/articlesShare?articleId=${this.articleId}&channel=${this.channelUID}&channelCode=P0700100`;
      const data = this.axios.get(
        "https://market.pyamc.com/api/user/weChat/getTicket",
        []
      );
      data.then((res) => {
        let tickt = res.data;
        if (tickt.code == "00000" && tickt.data != null) {
          console.log(tickt.data.appId);
          this.wxConfig.appId = tickt.data.appId;
          this.param.jsapi_ticket = tickt.data.ticket;
          this.param.noncestr = this.param.noncestr;
          this.param.url = this.signUrl;
          this.postChatGetTicket();
        }
      });
    },
    handleTip(name) {
      if(!isEmpty(name)){
        console.log(name)
        if (this.isFromApp) {
          let newsListParams = { articleListIndex: name };
          let mid = {
            action: "interactionMap",
            newsListParams: newsListParams,
          };
          let StrMid = JSON.stringify(mid);
          console.log(StrMid);
        } 
      }
    },
    postChatGetTicket() {
      let that = this;
      let config = this.axios.post(
        "https://market.pyamc.com/api/user/weChat/signature",
        this.param
      );
      config.then((res) => {
        let wxShare = JSON.parse(JSON.stringify(res)).data;
        if (wxShare.code == "00000" && wxShare.data != null) {
          this.wxConfig.timestamp = wxShare.data.timestamp;
          this.wxConfig.signature = wxShare.data.sign;
          this.wxConfig.nonceStr = this.param.noncestr;
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: that.wxConfig.appId, //congig.appId, // 必填，公众号的唯一标识，填自己的！
            timestamp: that.wxConfig.timestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
            nonceStr: that.wxConfig.nonceStr, // 必填，生成签名的随机串
            signature: that.wxConfig.signature, // 必填，签名，见附录1
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"],
          });
        }
        // 分享到朋友圈
        setTimeout(() => {
          wx.updateAppMessageShareData({
            title: that.articleData.title,
            desc: that.articleData.summary,
            link: this.signUrl, //`https://fat-promo.pyamc.com/cms-app-html/articlesShare?articleId=${that.articleId}&channel=201211&channelCode=P0700100`,
            imgUrl: "https://m.pyamc.com/trade/img/logo@2x.83ecec23.png",
            success: function () {
              console.log("分享成功");
            },
            fail: function () {
              console.log("分享失败");
            },
            cancel: function () {
              console.log("取消分享");
            },
          });

          wx.updateTimelineShareData({
            title: that.articleData.title,
            link: this.signUrl, //`https://fat-promo.pyamc.com/cms-app-html/articlesShare?articleId=${that.articleId}&channel=201211&channelCode=P0700100`,
            imgUrl: "https://m.pyamc.com/trade/img/logo@2x.83ecec23.png",
            success: function () {
              console.log("分享成功");
            },
            fail: function () {
              console.log("分享失败");
            },
            cancel: function () {
              console.log("取消分享");
            },
          });
        }, 300);
      });
    },
    // 判断是不是好基通自己的 webView
    isHJT() {
      let ua = navigator.userAgent;
      // let isPhone = ua.indexOf("iPhone") !== -1;
      console.log("isPhone:", ua.indexOf("iPhone") !== -1);
      return ua.indexOf("iPhone") !== -1;
    },
  },
  computed: {
    // 判断是否是app环境，true为app环境，false不是app环境
    isFromApp() {
      // return true
      var data = OpenInstall.parseUrlParams();
      console.log("isFromApp",data);
      return data.source === "APP" || data.source === "app";
    },
  },
};
</script>
<style lang="scss" scoped>
#id-article-share {
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
  padding-top: 1.707rem;
  background-color: #fff;
  //   .zz{
  //     width: 115px;
  //     display: inline-block;overflow: hidden;

  // text-overflow: ellipsis;

  // white-space: nowrap
  // }
  .article-main {
    padding: 0.667rem 0.427rem 0 0.427rem;
    .correlation {
      .correlation-title {
        font-size: 16px;
        border-left: 4px solid #ef3c34;
        font-weight: 500;
        margin: 10px 0;
        padding-left: 10px;
      }
      .correlation-cont {
        border-radius: 4px;
        background: #f5f5f5;
        padding: 15px;
        margin-bottom: 20px;
        .correlation-item {
          display: block;
          font-size: 14px;
          color: #222;
          margin-bottom: 12px;
          padding-bottom: 12px;
          border-bottom: 1px solid rgba($color: #000000, $alpha: 0.1);
          line-height:24px;
          font-weight: 400;
          &:last-child {
            margin-bottom: 0;
            padding-bottom: 0;
            border-bottom: none;
          }
        }
      }
    }
    .new-tip {
      font-size: 0.32rem;
      color: #ef3c34;
      padding: 0.02rem 0.2rem;
      margin: 0 0.2rem;
      border-radius:10rem;
      background-color: rgba($color: #ef3c34, $alpha: 0.1);
      transform: scale(0.85);
      font-weight: normal;
    }
    .article-title {
      font-family: PingFangSC-Medium;
      font-weight: 500;
      line-height: 0.8rem;
      font-size: 0.533rem;
      color: #222222;
      // font-weight: bold;
    }
    .article-info {
      margin-top: 0.533rem;
      display: flex;
      align-items: center;
      & > * {
        margin-right: 0.12rem;
      }
      .dian {
        margin: 0 0.11rem 0 0.11rem;
        align-items: center;
      }
      .items-center {
        align-items: center;
        line-height: 0.43rem;
      }
      .article-avatar {
        position: relative;
        width: 0.96rem;
        height: 0.96rem;
        border-radius: 50%;
        img {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      .article-name {
        font-size: 0.347rem;
        font-weight: bold;
        color: #333333;
        // margin-bottom: 0.05rem;
      }
      .article-time {
        font-family: PingFangSC-Regular;
        font-size: 0.32rem;
        color: #999999;
        font-weight: 400;
        margin-bottom: 0.02rem;
        .zz {
          max-width: 2.05rem;
          color: #333;
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .article-content {
      overflow-x: hidden;
      font-family: "PingFangSC-Regular", "微软雅黑", sans-serif;
      padding-top: 0.533rem;
      font-size: 0.427rem;
      color: #333333;
      line-height: 0.693rem;
      font-weight: 400;
      margin-bottom: 0.5rem;
    }
  }
  .flx {
    display: flex;
  }
}
.alert-warn {
  position: fixed;
  width: 100%;
  left: 0;
  top: 3rem;
  z-index: 10;
  .alert-content {
    width: 50%;
    margin: 0 auto;
    text-align: center;
    background: #fdf6ec;
    color: #e6a23c;
    line-height: 1rem;
    border-radius: 0.06rem;
    font-size: 16px;
  }
}
</style>
<!-- 
  transferFrom 转载字段
  managerImgPublicUrl 基金经理头像
  managerName 基金经理名称
  readingQuantity 阅读量
  postDate 发布时间
  一共四种状态：阅读量和发布时间一直会有，主要是以下四种状态的排版
    1.即没有转载也没有基金经理
    2.既有转载也有基金经理
    3.只有转载没有基金经理
    4.只有基金经理没有转载
  -->


// WEBPACK FOOTER //
// src/views/h5/ArticleShare.vue